import { CLIMBING_STYLES } from '../constants.js';

function roundToNearestGrade(grade) {
  if (grade === null || isNaN(grade)) return null;
  return Math.round(grade);
}

export const calculateGradeDistribution = (data, climbingStyle = CLIMBING_STYLES.SPORT, countDistinct = false) => {
  const gradeCount = {};

  if (countDistinct) {
    // Define ascent type priority (lower number = higher priority)
    const priority = {
      'Onsight': 1,
      'Flash': 2,
      'Red point': 3,
      'Pink point': 4,
      'Send': 3,
      'Repeat': 4,
      'First ascent': 3,
      'default': 5
    };


    // Create a Map to store the best ascent for each route
    const bestAscents = new Map();

    data?.forEach(ascent => {
      const routeId = ascent["Route ID"];
      if (!bestAscents.has(routeId)) {
        bestAscents.set(routeId, ascent);
      } else {
        const currentBest = bestAscents.get(routeId);

        const currentPriority = priority[ascent["Ascent Type"]] || priority.default;
        const bestPriority = priority[currentBest["Ascent Type"]] || priority.default;

        if (
          currentPriority < bestPriority ||
          (currentPriority === bestPriority &&
            (ascent.date < currentBest.date || 
             (ascent.date === currentBest.date && ascent["Ascent ID"] < currentBest["Ascent ID"])))
        ) {
          bestAscents.set(routeId, ascent);
        }
      }
    });
    
    // Count the best ascents
    for (const ascent of bestAscents.values()) {
      const grade = climbingStyle === CLIMBING_STYLES.BOULDER
        ? ascent.vgrade
        : roundToNearestGrade(ascent.ewbanks);

      if (grade !== null && !isNaN(grade)) {
        const gradeKey = grade.toString();

        if (!gradeCount[gradeKey]) {
          if (climbingStyle === CLIMBING_STYLES.BOULDER) {
            gradeCount[gradeKey] = {
              onsight: 0,
              flash: 0,
              send: 0,
              repeat: 0,
              attempts: 0,
              grade: parseFloat(gradeKey)
            };
          } else {
            gradeCount[gradeKey] = {
              onsight: 0,
              flash: 0,
              redpoint: 0,
              pinkpoint: 0,
              firstAscent: 0,
              attempts: 0,
              grade: parseFloat(gradeKey)
            };
          }
        }

        switch (ascent["Ascent Type"]) {
          case 'Onsight':
            gradeCount[gradeKey].onsight++;
            break;
          case 'Flash':
            gradeCount[gradeKey].flash++;
            break;
          case 'Red point':
            if (climbingStyle !== CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].redpoint++;
            }
            break;
          case 'Pink point':
            if (climbingStyle !== CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].pinkpoint++;
            }
            break;
          case 'First ascent':
            if (climbingStyle !== CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].firstAscent++;
            }
            break;
          case 'Send':
            if (climbingStyle === CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].send++;
            }
            break;
          case 'Repeat':
            if (climbingStyle === CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].repeat++;
            }
            break;
          case 'Hang dog':
          case 'Working':
          default:
            gradeCount[gradeKey].attempts++;
        }
      }
    }
  } else {
    // Original non-distinct counting logic remains unchanged
    data?.forEach(ascent => {
      const grade = climbingStyle === CLIMBING_STYLES.BOULDER
        ? ascent.vgrade
        : roundToNearestGrade(ascent.ewbanks);

      if (grade !== null && !isNaN(grade)) {
        const gradeKey = grade.toString();

        if (!gradeCount[gradeKey]) {
          if (climbingStyle === CLIMBING_STYLES.BOULDER) {
            gradeCount[gradeKey] = {
              onsight: 0,
              flash: 0,
              send: 0,
              repeat: 0,
              attempts: 0,
              grade: parseFloat(gradeKey)
            };
          } else {
            gradeCount[gradeKey] = {
              onsight: 0,
              flash: 0,
              redpoint: 0,
              pinkpoint: 0,
              firstAscent: 0,
              attempts: 0,
              grade: parseFloat(gradeKey)
            };
          }
        }

        switch (ascent["Ascent Type"]) {
          case 'Onsight':
            gradeCount[gradeKey].onsight++;
            break;
          case 'Flash':
            gradeCount[gradeKey].flash++;
            break;
          case 'Red point':
            if (climbingStyle !== CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].redpoint++;
            }
            break;
          case 'Pink point':
            if (climbingStyle !== CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].pinkpoint++;
            }
            break;
          case 'First ascent':
            if (climbingStyle !== CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].firstAscent++;
            }
            break;
          case 'Send':
            if (climbingStyle === CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].send++;
            } else {
              gradeCount[gradeKey].attempts++;
            }
            break;
          case 'Repeat':
            if (climbingStyle === CLIMBING_STYLES.BOULDER) {
              gradeCount[gradeKey].repeat++;
            } else {
              gradeCount[gradeKey].attempts++;
            }
            break;
          case 'Hang dog':
          case 'Working':
          default:
            gradeCount[gradeKey].attempts++;
        }
      }
    });
  }

  return Object.values(gradeCount).sort((a, b) => a.grade - b.grade);
};
